import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  field: {
    width: '50%',
    marginRight: '20px',
    marginBottom: '30px'
  }
});

export default useStyles;
